// Lint exception: camera calibration values
import type { CameraVector, CameraViewConfig } from "./camera.types.js";

export const CAMERA_VIEW = {
  absoluteMaxDistance: 5000,
  absoluteMaxDistanceFactor: 4,
  absoluteMinDistance: 1,
  absoluteMinDistanceFactor: 0.25,
  fov: 25,
  initialPosition: [-21.73, 74.1, 80.8] as CameraVector,
  maxPolarAngle: Math.PI / 2 - 0.05,
  minPolarAngle: 0.01,
  minViewportSize: 1,
  near: 0.1,
} as const;

export const VIEW_DEFAULTS: Record<"desktop" | "mobile", CameraViewConfig> = {
  desktop: {
    ambientLight: 2.5,
    azimuthAngle: { max: 0.25, min: -1.02 },
    directionalLight: 2,
    fitPaddingFactor: 1.12,
    maxDistanceFactor: 2,
    minDistanceFactor: 0.7,
    polarAngle: { max: 1.47, min: 0.67 },
  },
  mobile: {
    ambientLight: 2,
    azimuthAngle: { max: 0, min: 0 },
    directionalLight: 0.1,
    fitPaddingFactor: 1.18,
    maxDistanceFactor: 2.2,
    minDistanceFactor: 0.65,
    polarAngle: {
      max: CAMERA_VIEW.minPolarAngle,
      min: CAMERA_VIEW.minPolarAngle,
    },
  },
} as const;

export const OFFICE_CAMERA_LIGHT_POSITIONS = {
  ambient: [0, 5, 0] as CameraVector,
  directional: [0, 5, 10] as CameraVector,
} as const;
